export const accountRouters = {
  path: 'account',
  name: 'account',
  component: () => import('@/views/account/Layout'),
  redirect: 'account',
  children: [
    {
      path: '',
      name: 'profile',
      component: () => import('@/views/account/Index')
    }
  ]
}
